import { FormsVisibility, FormTemplateTypeNewApi } from 'constants/forms';
import { formApplicationTypeConverter, getGeographicalState } from 'utils/forms';

export const formsApiConvertPOSTData = (form, applicationId) => ({
  name: form.name,
  geographicalState: getGeographicalState(form),
  visibility: {
    type: applicationId ? FormsVisibility.FOR_LOAN : FormsVisibility.FOR_COMPANY,
    applicationId,
  },
  template: {
    type: form.isUploadPdf ? FormTemplateTypeNewApi.PDF : FormTemplateTypeNewApi.EMPTY_HTML,
  },
  documentTypeId: form.documentType.value,
  type: formApplicationTypeConverter(form.formApplicationType?.value),
  withPageNumbers: form.withPageNumbers,
  disclosureType: form.disclosureType?.value || null,
  purposeType: form.purposeType?.value || null,
  formPurpose: form.formPurpose?.value || null,
});
